import PageHeader from "@/components/page-header";
import { ContextHelpButton } from "@/components/registrant/help/context-help-button";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import ErrorComponent from "@/components/ui/error";
import LoadingScreen from "@/components/ui/loading-screen";
import { getOmtAmsAccount } from "@/hera-api/omt-ams-api";
import { useAuthQuerySetup } from "@/hooks/use-auth-query-setup";
import { getQueryErrorMessage } from "@/lib/utils";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/omt-ams/account")({
  component: OmtAmsAccountPage,
});

function OmtAmsAccountPage() {
  const { isAuthSetupComplete } = useAuthQuerySetup();
  const { data, isLoading, error } = useQuery({
    queryKey: ["omt-ams-account"],
    queryFn: getOmtAmsAccount,
    enabled: isAuthSetupComplete,
  });

  if (!isAuthSetupComplete) {
    return <LoadingScreen message="Authenticating..." />;
  }
  if (isLoading) {
    return <LoadingScreen message="Loading account..." />;
  }
  if (error) {
    return (
      <ErrorComponent
        title="Could not load account"
        message={getQueryErrorMessage(error)}
      />
    );
  }

  return (
    <div className="flex flex-col container mx-auto max-w-3xl">
      <PageHeader
        title="Account"
        subtitle="OMT/AMS portal profile"
        className="mb-6"
        action={<ContextHelpButton articleId="account" helpPortal="omt-ams" />}
      />
      <Card>
        <CardContent className="space-y-3 pt-6">
          <div>
            <p className="text-sm text-muted-foreground">Email</p>
            <p className="font-medium">{data?.email}</p>
          </div>
          {data?.name ? (
            <div>
              <p className="text-sm text-muted-foreground">Name</p>
              <p className="font-medium">{data.name}</p>
            </div>
          ) : null}
          <p className="text-sm text-muted-foreground">
            This portal is view-only. Use Auth0 forgot-password from the login
            screen to change your password.
          </p>
          <Button asChild variant="outline">
            <a href="/omt-ams/dashboard">Back to dashboard</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
